export class CopyField {
	readonly $container: HTMLElement;
	private $value: HTMLElement | null = null;
	private $button: HTMLButtonElement | null = null;

	private readonly classCopied = 'copy-field__button--copied';
	private readonly classError = 'copy-field__button--error';

	private autoReset: boolean = true;
	private resetDelay: number = 3000;

	constructor(selector: HTMLElement) {
		this.$container = selector;
		if (!this.$container) return;

		this.init();
	}

	private init(): void {
		this.$value = this.$container.querySelector('.js-copy-field__value');
		this.$button = this.$container.querySelector('.js-copy-field__button');

		if (!this.$value || !this.$button) return;

		this.$button.addEventListener('click', this.copy);
	}

	private copy = (): void => {
		if (!this.$value || !this.$button) return;

		const text = (this.$value.textContent || '').trim();
		const isSecure = window.location.protocol === 'https:';

		const markSuccess = () => this.handleSuccess();
		const markFailure = () => this.handleFailure();

		if (isSecure && navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard
				.writeText(text)
				.then(markSuccess)
				.catch(() => {
					this.fallbackCopy(text) ? markSuccess() : markFailure();
				});
			return;
		}

		this.fallbackCopy(text) ? markSuccess() : markFailure();
	};

	private handleSuccess(): void {
		if (!this.$button) return;

		this.$button.classList.add(this.classCopied);

		if (this.autoReset) {
			setTimeout(() => {
				this.$button && this.$button.classList.remove(this.classCopied);
			}, this.resetDelay);
		}
	}

	private handleFailure(): void {
		if (!this.$button) return;

		this.$button.classList.add(this.classError);

		if (this.autoReset) {
			setTimeout(() => {
				this.$button && this.$button.classList.remove(this.classError);
			}, this.resetDelay);
		}
	}

	private fallbackCopy(text: string): boolean {
		const textarea = document.createElement('textarea');
		textarea.value = text;

		textarea.style.position = 'fixed';
		textarea.style.top = '-9999px';
		textarea.style.opacity = '0';

		document.body.appendChild(textarea);
		textarea.focus();
		textarea.select();

		let success = true;

		try {
			success = document.execCommand('copy');
		} catch (e) {
			console.error('Fallback copy failed:', e);
			success = false;
		}

		document.body.removeChild(textarea);
		return success;
	}

	public destroy(): void {
		this.$button?.removeEventListener('click', this.copy);
	}
}
